import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  mainDiv: {
    display: "flex",
    flexDirection: "column",
    padding: "12px 12px 12px 0px"
  },
  whenDiv: {
    display: "flex",
    flexDirection: "column"
  },
  whenUpperTitle: {
    fontSize: "10px",
    fontFamily: "Manrope",
    color: "#9CA6AF",
    lineHeight: "10px"
  },
  iconTitleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  iconTitle: {
    marginRight: 12,
    marginLeft: "5.5px"
  },
  title: {
    fontSize: "18px",
    fontFamily: "Manrope",
    color: "#465869",
    fontWeight: 700,
    lineHeight: "24px",
    marginBottom: "10px"
  },
  titleItem: {
    fontSize: "14px",
    fontFamily: "Manrope",
    color: "#465869",
    fontWeight: 700,
    lineHeight: "21px",
    paddingLeft: 8,
    marginTop: 8
  },
  titleGrid: {
    margin: "11px 0px"
  },
  whenGrid: {
    margin: "0px 0px 8px 0px"
  },
  instructionItemGrid: {
    padding: "6px 0px 8px 8px"
  },
  actionsItemGrid: {
    padding: "12px 12px 12px 8px"
  },
  line: {
    height: "1px",
    width: "100%",
    backgroundColor: "#CCDEEE",
    marginBottom: "20px",
    marginLeft: "6px"
  },
  secondaryLine: {
    height: "1px",
    width: "99%",
    backgroundColor: "#CCDEEE",
    marginBottom: "20px"
  },
  remarkField: {
    width: "100%"
  },
  deleteButton: {
    color: "#CF4842"
  },
  remarkDiv: {
    padding: "12px 12px 12px 0px"
  },
  remark: {
    fontSize: "12px",
    fontFamily: "Manrope",
    fontWeight: 400,
    fontStyle: "Normal",
    color: "#465869"
  },
  remarkDescription: {
    fontSize: "12px",
    fontFamily: "Manrope",
    fontWeight: 400,
    fontStyle: "Normal",
    color: "#9CA6AF",
    marginLeft: "5px"
  },
  instructionItemDiv: {
    display: "flex",
    width: "100%",
    padding: "12px 12px 12px 8px",
    gap: "0.1rem"
  }
}));

export default styles;
